/** @format */

import { TTrigger } from "../declarations/maps/triggers";
import { TStore } from "../declarations/store";

export const selectorTriggerList = (store: TStore): TTrigger[] => store.triggers.triggerList || [];

export const selectorTrigger = (store: TStore, id: string): TTrigger | undefined =>
  store.triggers.triggerList?.find(trigger => trigger.id === id) || undefined;
